/*
   Helpers para persistir el access_token de compras en localStorage.
   El token vive lo que vive la compra; localStorage sobrevive cierre de tab,
   reinicio de PC y corte de luz. Si el usuario lo pierde (limpia browser /
   incógnito), el PDF adjunto en el mail de confirmación es el canal oficial
   de recuperación.
*/

const STORAGE_KEY = 'compra_access_tokens';

type TokenMap = Record<string, string>;

function readMap(): TokenMap {
    if (typeof window === 'undefined') return {};
    try {
        const raw = window.localStorage.getItem(STORAGE_KEY);
        return raw ? (JSON.parse(raw) as TokenMap) : {};
    } catch {
        return {};
    }
}

function writeMap(map: TokenMap): void {
    if (typeof window === 'undefined') return;
    try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
    } catch {
        /* quota / privacy mode — silent fail; el usuario tiene plan B (PDF en mail) */
    }
}

export function getCompraAccessToken(compraId: string | number | null | undefined): string | null {
    if (!compraId) return null;
    const value = readMap()[String(compraId)];
    return typeof value === 'string' ? value : null;
}

export function setCompraAccessToken(compraId: string | number, token: string): void {
    if (!compraId || !token) return;
    const map = readMap();
    map[String(compraId)] = token;
    writeMap(map);
}

export function clearCompraAccessToken(compraId: string | number): void {
    if (!compraId) return;
    const map = readMap();
    delete map[String(compraId)];
    writeMap(map);
}
